const Layout = () => import('@/layout/index.vue')

export default {
    path: '/membership',
    component: Layout,
    redirect: '/membership/config',
    name: 'Membership',
    meta: {
        title: 'vip管理',
        icon: 'users-member',
        defaultOpened: true,
        auth: ['Membership']
    },
    children: [
        {
            path: 'config',
            name: 'Config',
            component: () => import('@/views/membership/config/index.vue'),
            meta: {
                title: '会员设置',
                icon: 'agent-code',
                auth: ['Config']
            }
        },
        {
            path: 'computing-power',
            name: 'ComputingPowerSettings',
            component: () => import('@/views/membership/computingPower/index.vue'),
            meta: {
                title: '算力点设置',
                icon: 'agent-point',
                auth: ['ComputingPowerSettings']
            }
        },
        {
            path: 'order',
            name: 'Order',
            component: () => import('@/views/membership/order/index.vue'),
            meta: {
                title: '订单管理',
                icon: 'agent-point',
                auth: ['Order']
            }
        },
        // {
        //     path: 'redemption',
        //     name: 'Redemption',
        //     component: () => import('@/views/membership/redemption/index.vue'),
        //     meta: {
        //         title: '会员兑换码',
        //         icon: 'shop-collect',
        //         auth: ['Redemption']
        //     }
        // },
        {
            path: 'exchange',
            name: 'ExchangeManagement',
            component: () => import('@/views/membership/exchange/index.vue'),
            meta: {
                title: '兑换管理',
                icon: 'shop-collect',
                auth: ['ExchangeManagement']
            }
        },
        {
            path: 'exchange-details',
            name: 'ExchangeDetails',
            component: () => import('@/views/membership/exchangeDetails/index.vue'),
            meta: {
                title: '兑换明细',
                icon: 'code-member',
                auth: ['ExchangeDetails']
            }
        },
        {
            path: 'computing-power-details',
            name: 'ComputingPowerDetails',
            component: () => import('@/views/membership/computingPowerDetails/index.vue'),
            meta: {
                title: '算力点明细',
                icon: 'agent-point',
                auth: ['ComputingPowerDetails']
            }
        }
    ]
}
